import React from 'react'
import MonetizationOn from '@mui/icons-material/MonetizationOn'
import { Box, Stack, Typography, Link } from '@mui/material'
import { getStyles } from '@utils/styles'
import defaultStyles from './styles'

export type AiCreditData = {
  title?: string
  linkInfo?: {
    link: string
    label: string
  }
  creditAmount?: number
}

export function AiCredit({
  title,
  linkInfo,
  creditAmount = 500,
}: AiCreditData) {
  const styles = getStyles(defaultStyles)

  return (
    <Box {...styles('wrapper')}>
      <Stack {...styles('textContent')}>
        <Typography {...styles('title')}>{title}</Typography>
        <Link
          {...styles('learnMoreLink')}
          href={linkInfo?.link}
          underline="always"
        >
          {linkInfo?.label}
        </Link>
      </Stack>
      <Box {...styles('creditPill')}>
        <MonetizationOn sx={{ color: '#FFC107', fontSize: '24px' }} />
        <Typography {...styles('creditAmount')}>
          {creditAmount} credits
        </Typography>
      </Box>
    </Box>
  )
}
